import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/sephoraMachineLearningModelV2/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showSephoraMLModelV2PromosSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showSephoraMLModelV2PromosSelector };
